<script>
    const imgBasePath = "";
    export default
    {
        /*----------------------------------------------------------------------------------------------------------------*/
        "topbox":{
        bgImgSrc:imgBasePath+ "img/topbg.svg"
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "topMenuItem":[
        {
            "key":2,
            "icon":imgBasePath+ "img/order.svg",
            "name": "我的订单",
            "url": "https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
        },
        {
            "key":3,
            "icon": imgBasePath+"img/aftersale.svg",
            "name": "我的售后",
            "url": "https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
        },
        {
            "key":4,
            "icon": imgBasePath+"img/address.svg",
            "name": "我的地址",
            "url": "https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
        }
    ],
            /*----------------------------------------------------------------------------------------------------------------*/
        "logo":{
        "imgSrc":imgBasePath+"img/kingdeelogo.png"
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "location":{
        "icon": imgBasePath+"img/location.svg",
            "name": "深圳",
            "url": "https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "cart":{
        "icon": imgBasePath+"img/cart.svg",
            "name": "购物车",
            "url": "https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "malSwiper": {
        "swiperSlide": [
            {
                "imgSrc": "http://y.gtimg.cn/music/photo_new/T003R720x288M000001YCZlY3aBifi.jpg",
                "url":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                "imgSrc": "http://y.gtimg.cn/music/photo_new/T003R720x288M000004ckGfg3zaho0.jpg",
                "url":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                "imgSrc": "http://y.gtimg.cn/music/photo_new/T003R720x288M00000236sfA406cmk.jpg",
                "url":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                "imgSrc": "http://y.gtimg.cn/music/photo_new/T003R720x288M000001s0BXx3Zxcwb.jpg",
                "url":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            }
        ],
            "option":{
            "delay":3000,//默认3秒切换一次
                "speed":1000//切换速度
        }
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "nav":{
        bgColor:/*"#6E6568"*/"green",
            fontColor:"#FFF",
            isShowAlways:false,
            navItems :[[{"number":"600","children":[{"number":"601","children":[{"number":"605","children":[],"level":3,"name":"暗影精灵","id":"542582989066896384","longNumber":"600.601.605","parentid":"509121834663349248"}],"level":2,"name":"台式电脑","id":"509121834663349248","longNumber":"600.601","parentid":"509121642992045056"},{"number":"602","children":[{"number":"604","children":[],"level":3,"name":"惠普笔记本","id":"541162619030050816","longNumber":"600.602.604","parentid":"509122113081248768"},{"number":"603","children":[],"level":3,"name":"联想笔记本","id":"509122430162242560","longNumber":"600.602.603","parentid":"509122113081248768"}],"level":2,"name":"笔记本","id":"509122113081248768","longNumber":"600.602","parentid":"509121642992045056"}],"level":1,"name":"电脑","id":"509121642992045056","longNumber":"600","parentid":""},{"number":"701","children":[{"number":"702","children":[],"level":2,"name":"摄像头","id":"539007883656845312","longNumber":"701.702","parentid":"539007458245367808"}],"level":1,"name":"数码","id":"539007458245367808","longNumber":"701","parentid":""}],[{"number":"500","children":[{"number":"501","children":[{"number":"502","children":[],"level":3,"name":"华为手机","id":"509121387449879552","longNumber":"500.501.502","parentid":"509121006699351040"}],"level":2,"name":"手机通讯","id":"509121006699351040","longNumber":"500.501","parentid":"509120792840178688"}],"level":1,"name":"手机","id":"509120792840178688","longNumber":"500","parentid":""},{"number":"600","children":[{"number":"601","children":[{"number":"605","children":[],"level":3,"name":"暗影精灵","id":"542582989066896384","longNumber":"600.601.605","parentid":"509121834663349248"}],"level":2,"name":"台式电脑","id":"509121834663349248","longNumber":"600.601","parentid":"509121642992045056"},{"number":"602","children":[{"number":"604","children":[],"level":3,"name":"惠普笔记本","id":"541162619030050816","longNumber":"600.602.604","parentid":"509122113081248768"},{"number":"603","children":[],"level":3,"name":"联想笔记本","id":"509122430162242560","longNumber":"600.602.603","parentid":"509122113081248768"}],"level":2,"name":"笔记本","id":"509122113081248768","longNumber":"600.602","parentid":"509121642992045056"}],"level":1,"name":"电脑","id":"509121642992045056","longNumber":"600","parentid":""}]]
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        "cardBody":[
        //热销商品
        {
            "cardOption":{
                "moreUrl":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src",
                "leftImg":imgBasePath+"img/hotsale.svg",
                speed:1000
            },
            "goodsGroup":[//对应一个轮播商品组
                [
                    {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价','促销']},
                    {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: imgBasePath+'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath:imgBasePath+ 'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 12.5英寸', shopPrice: '3599元', productImgPath: imgBasePath+'img/h-a-r-4.jpg', link: 'https://item.mi.com/product/10000032.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']}
                ],//对应一个轮播
                [
                    {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价','促销']},
                    {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: imgBasePath+'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath:imgBasePath+ 'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 12.5英寸', shopPrice: '3599元', productImgPath:imgBasePath+ 'img/h-a-r-4.jpg', link: 'https://item.mi.com/product/10000032.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']}
                ]
            ]
        },
        //新品上市
        {
            "cardOption":{
                "moreUrl":"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src",
                "leftImg":"img/newpro.svg",
                speed:1000
            },
            "goodsGroup":[//对应一个轮播商品组
                [
                    {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价','促销']},
                    {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath:imgBasePath+ 'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath: imgBasePath+'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 12.5英寸', shopPrice: '3599元', productImgPath:imgBasePath+ 'img/h-a-r-4.jpg', link: 'https://item.mi.com/product/10000032.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']}
                ],//对应一个轮播
                [
                    {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价','促销']},
                    {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: imgBasePath+'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath: imgBasePath+'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']},
                    {productName: '小米笔记本Air 12.5英寸', shopPrice: '3599元', productImgPath: imgBasePath+'img/h-a-r-4.jpg', link: 'https://item.mi.com/product/10000032.html',supplier:"撒的发生的发送到发送到发送到发顺丰",tags:['签约商品','降价']}
                ]
            ]
        }
    ],
            /*----------------------------------------------------------------------    ------------------------------------------*/
        storeBody:{
        storeOption:{
            leftImg:imgBasePath+'img/highquality.svg'
        },
        shops:[
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },

            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            },
            {
                imgSrc:"http://www.nbdeli.com/formwork/default/images/logo.gif",
                url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
            }
        ]
    },
        /*----------------------------------------------------------------------------------------------------------------*/
        categoryGoodsShow:{
            maxScrollNum:9,
                categoryGoods:[
                {
                    category:{
                        name:"手提电脑",
                        number:500,
                        url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
                    },
                    goods:[
                        {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: imgBasePath+'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath: imgBasePath+'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰"}
                    ]
                },
                {
                    category:{
                        name:"手提电脑",
                        number:500,
                        url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
                    },
                    goods:[
                        {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: imgBasePath+'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: imgBasePath+'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米笔记本Air 13.3英寸小米笔记本Air 13.3英寸小米笔记本Air 13.3英寸小米笔记本Air 13.3英寸小米笔记本Air 13.3英寸小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath: imgBasePath+'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰"}
                    ]
                },
                {
                    category:{
                        name:"手提电脑",
                        number:500,
                        url:"https://gitee.com/cyrainfall/mal-mainpage-ui/tree/master/src"
                    },
                    goods:[
                        {productName: '小米电视4A 43英寸',  shopPrice: '2099元', productImgPath: 'img/h-a-r-1.png', link: 'https://item.mi.com/1170900021.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米电视4 55英寸',  shopPrice: '3999元', productImgPath: 'img/h-a-r-2.jpg', link: 'https://item.mi.com/1171600035.html',supplier:"撒的发生的发送到发送到发送到发顺丰"},
                        {productName: '小米笔记本Air 13.3英寸',shopPrice: '4999元', productImgPath: 'img/h-a-r-3.jpg', link: 'https://item.mi.com/product/10000061.html',supplier:"撒的发生的发送到发送到发送到发顺丰"}
                    ]
                }
            ]}
    }
</script>